import { patternLabel } from 'features/top-three-profiles/topThreeProfiles';

export function OrderedPatternTrail({ first, second, third, locale, t }) {
  const items = [
    { rank: 1, pattern: first, label: t('profiles.firstPattern') },
    { rank: 2, pattern: second, label: t('profiles.secondPattern') },
    { rank: 3, pattern: third, label: t('profiles.thirdPattern') },
  ];

  return (
    <ol className="pattern-trail" data-testid="pattern-trail" aria-label={t('profiles.orderedPatterns')}>
      {items.map((item) => (
        <li key={item.rank} className="pattern-trail-item" aria-label={`${item.rank}. ${item.label}: ${patternLabel(item.pattern, locale)}`}>
          <span className="pattern-trail-rank" aria-hidden="true">{item.rank}. </span>
          <span className="pattern-trail-name">{patternLabel(item.pattern, locale)}</span>
        </li>
      ))}
    </ol>
  );
}

export function CanonicalKey({ value }) {
  return (
    <code className="ltr-id canonical-key" dir="ltr" data-testid="canonical-key">
      {value || '—'}
    </code>
  );
}
